import React from 'react'

const SettingsDefault = () => (
  <div className="jumbotron">
    <h1>Settings</h1>
    <p className="lead">Choose settings from the menu.</p>
  </div>
)

export default SettingsDefault



// WEBPACK FOOTER //
// ./src/containers/Settings/default.js